import React, { FC, useMemo } from "react"
import { Text } from "dash-styled"
import { Customer } from "../../../../../../Models/API/BackofficeModel"
import { format } from "date-fns/esm"
import { calculateFreemiumPlanExpiry } from "../../../../../../Models/API/UserModel"

interface CustomerInfoProps {
    customer: Customer
}

export const CustomerInfo: FC<CustomerInfoProps> = ({ customer }) => {
    const trialRemaining = useMemo(
        () => calculateFreemiumPlanExpiry(customer),
        [customer]
    )
    return (
        <div className="flex-grow">
            <Text size="xl" weight="semibold">
                Account details
            </Text>
            <div className="grid grid-cols-3 gap-y-1">
                <DetailRow name="Email" value={customer.email} />
                <DetailRow
                    name="Created"
                    value={format(new Date(customer.created), "dd.MM.yyyy")}
                />
                <DetailRow
                    name="Account type"
                    value={`${customer.plan}${
                        trialRemaining !== undefined
                            ? trialRemaining > 0
                                ? ` (${trialRemaining} day${
                                      trialRemaining > 1 ? "s" : ""
                                  } remaining)`
                                : ` (Expired)`
                            : ""
                    }`}
                />
            </div>
        </div>
    )
}

interface DetailRowProps {
    name: string
    value: string
}
const DetailRow: FC<DetailRowProps> = ({ name, value }) => {
    return (
        <>
            <Text className="m-0" weight="semibold">
                {name}:
            </Text>
            <Text className="m-0 break-words hyphens-auto col-span-2">
                {value}
            </Text>
        </>
    )
}
